module.exports = __webpack_public_path__ + "img/title.d8ce6c4d.webp";